export default "__VITE_ASSET__BLZM32Br__"